import { useState, useEffect } from "react";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from './FormatDate';

import { useLoaderData, useParams } from "react-router-dom";

import coordTavad from ".//images/coordinador-red-tavad-firma.jpg";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

export function CertInfTratField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  autoTratamientoData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;

  const [docResp, setDocResp] = useState(
    savedData?.docResp ? savedData?.docResp : especialistaFullName
  );
  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );
  const [docDni, setDocDni] = useState(
    savedData?.docDni ? savedData?.docDni : autoPacienteData?.meta?.dni
  );

  const [docAdicc, setDocAdicc] = useState(
    savedData?.docAdicc ? savedData?.docAdicc : undefined
  );
  const [docInicIngr, setDocInicIngr] = useState(
    savedData?.docInicIngr
      ? savedData?.docInicIngr
      : autoTratamientoData?.meta?.fecha
  );
  const [docFinIngr, setDocFinIngr] = useState(
    savedData?.docFinIngr ? savedData?.docFinIngr : undefined
  );
  const [docFechUltSes, setDocFechUltSes] = useState(
    savedData?.docFechUltSes ? savedData?.docFechUltSes : undefined
  );
  const [docProgCons, setDocProgCons] = useState(
    savedData?.docProgCons ? savedData?.docProgCons : undefined
  );
  const [docFechIngrRef, setDocFechIngrRef] = useState(
    savedData?.docFechIngrRef ? savedData?.docFechIngrRef : undefined
  );
  const [docFechAlt, setDocFechAlt] = useState(
    savedData?.docFechAlt ? savedData?.docFechAlt : undefined
  );

  let data = {
    docResp: docResp,
    docFecha: docFecha,
    docPacie: docPacie,
    docDni: docDni,
    docAdicc: docAdicc,
    docInicIngr: docInicIngr,
    docFinIngr: docFinIngr,
    docFechUltSes: docFechUltSes,
    docProgCons: docProgCons,
    docFechIngrRef: docFechIngrRef,
    docFechAlt: docFechAlt,
  };

  useEffect(() => {
    updateData(data);
  }, [
    docResp,
    docFecha,
    docPacie,
    docDni,
    docAdicc,
    docInicIngr,
    docFinIngr,
    docFechUltSes,
    docProgCons,
    docFechIngrRef,
    docFechAlt,
  ]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/CertInfTrat.docx"
      );
      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      doc.setData({
        date: FormatDate(docFecha),
        responsable: docResp,
        paciente: docPacie,
        dni: docDni,
        adiccion: docAdicc,
        fechaInicioIngreso: FormatDate(docInicIngr),
        fechaFinIngreso: FormatDate(docFinIngr),
        fechaUltSesion: FormatDate(docFechUltSes),
        progrConsultas: docProgCons,
        fechaIngrRefuerzo: FormatDate(docFechIngrRef),
        fechaAlta: FormatDate(docFechAlt),
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "certificado-informe-tratamiento.docx");
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [
    docResp,
    docFecha,
    docPacie,
    docDni,
    docAdicc,
    docInicIngr,
    docFinIngr,
    docFechUltSes,
    docProgCons,
    docFechIngrRef,
    docFechAlt,
  ]);

  return (
    <>
      <div className='docFormContainer'>
      <div className="grid--2col">
        <div className='field'>
          <label htmlFor='docFecha'>Fecha</label>
          <div className='control'>
            <input
              className='input'
              id='docFecha'
              required
              type='date'
              value={docFecha}
              onChange={(e) => setDocFecha(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docPacie'>Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docPacie'
              required
              type='text'
              value={docPacie}
              onChange={(e) => setDocPacie(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDni'>DNI Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docDni'
              required
              type='text'
              value={docDni}
              onChange={(e) => setDocDni(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docAdicc'>Adicción</label>
          <div className='control'>
            <input
              className='input'
              id='docAdicc'
              required
              type='text'
              value={docAdicc}
              onChange={(e) => setDocAdicc(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docInicIngr'>Fecha de inicio de ingreso</label>
          <div className='control'>
            <input
              className='input'
              id='docInicIngr'
              required
              type='date'
              value={docInicIngr}
              onChange={(e) => setDocInicIngr(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFinIngr'>Fecha de fin de ingreso</label>
          <div className='control'>
            <input
              className='input'
              id='docFinIngr'
              required
              type='date'
              value={docFinIngr}
              onChange={(e) => setDocFinIngr(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFechUltSes'>Última sesión</label>
          <div className='control'>
            <input
              className='input'
              id='docFechUltSes'
              required
              type='date'
              value={docFechUltSes}
              onChange={(e) => setDocFechUltSes(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docProgCons'>Programa de consultas</label>
          <div className='control'>
            <input
              className='input'
              id='docProgCons'
              required
              type='text'
              value={docProgCons}
              onChange={(e) => setDocProgCons(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFechIngrRef'>Fecha de ingreso de Refuerzo</label>
          <div className='control'>
            <input
              className='input'
              id='docFechIngrRef'
              required
              type='date'
              value={docFechIngrRef}
              onChange={(e) => setDocFechIngrRef(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docFechAlt'>Fecha de alta</label>
          <div className='control'>
            <input
              className='input'
              id='docFechAlt'
              required
              type='date'
              value={docFechAlt}
              onChange={(e) => setDocFechAlt(e.target.value)}
            />
          </div>
        </div>
        </div>
      </div>
      <div className='btn-dwnld'>
        {showDocxLink && (
          <a className='button is-link' href='#!' onClick={generateDocx}>
            Descargar DOCX
          </a>
        )}
      </div>

      
    </>
  );
}


